import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { TrainingDomainsHeadingRoutingModule } from './training-domains-heading-routing.module';
import { TrainingDomainsHeadingListComponent } from './training-domains-heading-list/training-domains-heading-list.component';
import { TrainingDomainsHeadingCreateComponent } from './training-domains-heading-create/training-domains-heading-create.component';

@NgModule({
  declarations: [TrainingDomainsHeadingListComponent, TrainingDomainsHeadingCreateComponent],
  imports: [
    CommonModule,
    TrainingDomainsHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class TrainingDomainsHeadingModule { }
